import gql from 'graphql-tag';
import { cookieValueFieldsFragment } from '../fragments';

export const exchangeAuthCodeMutation = gql`
  mutation ExchangeAuthCode($code: String!, $state: String!) {
    exchangeAuthCode(code: $code, state: $state) {
      success
      cookies {
        ...CookieValueFields
      }
    }
  }
  ${cookieValueFieldsFragment}
`;
